import { render, staticRenderFns } from "./DriverDetail.vue?vue&type=template&id=86e8c58c&scoped=true&"
import script from "./DriverDetail.vue?vue&type=script&lang=js&"
export * from "./DriverDetail.vue?vue&type=script&lang=js&"
import style0 from "./DriverDetail.vue?vue&type=style&index=0&id=86e8c58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e8c58c",
  null
  
)

export default component.exports